import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getWorkInformationStart,
  getWorkInformationSuccess,
  getWorkInformationFailed,
} from "../redux/getWorkInformation";

import { getWorkInformationApi } from "core/http/service/personnelInformation";

function* getWorkInformationWork() {
  try {
    const res = yield call(getWorkInformationApi);

    yield put({
      type: getWorkInformationSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getWorkInformationFailed.type,
    });
  }
}

function* watchGetWorkInformation() {
  yield takeLatest(getWorkInformationStart.type, getWorkInformationWork);
}

export default function* getWorkInformationSaga() {
  yield all([watchGetWorkInformation()]);
}
